/**
 * Assorbe il click/tap fantasma dopo chiusura modal/dropdown (iOS/Android WebView).
 * AbortController garantisce il remove anche se si naviga via prima del timeout.
 *
 * @param {number} [ms]
 * @returns {() => void} dispose
 */
export const CLICK_SHIELD_MS = 500;
/** WebView app: i ghost click arrivano più tardi del browser desktop. */
export const CLICK_SHIELD_APP_MS = 1200;

let disposeActiveShield = null;

export const isFromAppClient = () => Boolean(localStorage.getItem('fromApp'));

export const armClickShield = (ms) => {
  const duration =
    ms ?? (isFromAppClient() ? CLICK_SHIELD_APP_MS : CLICK_SHIELD_MS);

  disposeActiveShield?.();
  disposeActiveShield = null;

  const controller = new AbortController();
  const suppress = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };
  // click/pointerup: assorbono il tap fantasma WebView senza bloccare i CTA della landing.
  const types = ['click', 'pointerup', 'mouseup', 'touchend'];
  types.forEach((type) => {
    document.addEventListener(type, suppress, { capture: true, signal: controller.signal });
  });
  const timer = window.setTimeout(() => {
    controller.abort();
    if (disposeActiveShield === dispose) disposeActiveShield = null;
  }, duration);

  const dispose = () => {
    window.clearTimeout(timer);
    controller.abort();
    if (disposeActiveShield === dispose) disposeActiveShield = null;
  };
  disposeActiveShield = dispose;
  return dispose;
};
